<template>
  <div style="width: auto; padding: 40px 0 20px 0">
    <div class="container">
      <div style="width: 49%; height: 100%; position: relative">
        <div class="template">
          <div class="title">学业水平评价记录表</div>
          <div class="term">
            <span>
              （
              <u>&emsp;{{ reportData.termStartYear }}&emsp;</u>—
              <u>&emsp;{{ reportData.termEndYear }}&emsp;</u>学年度第{{
                reportData.secondTerm ? "二" : "一"
              }}学期 </span
            >）
          </div>

          <div class="table-container">
            <table
              cellpadding="28"
              style="height: 100%; width: 100%; margin: 0"
            >
              <tr>
                <td :colspan="reportData.secondTerm ? '4' : '5'">
                  科&emsp;&emsp;目
                </td>
                <td :colspan="reportData.secondTerm ? '4' : '5'">
                  平&emsp;&emsp;时
                </td>
                <td :colspan="reportData.secondTerm ? '4' : '5'">
                  期&emsp;&emsp;中
                </td>
                <td :colspan="reportData.secondTerm ? '4' : '5'">
                  期&emsp;&emsp;末
                </td>
                <td :colspan="reportData.secondTerm ? '4' : '4'">
                  学&emsp;&emsp;期
                </td>
                <td colspan="4" v-if="reportData.secondTerm">
                  学&emsp;&emsp;年
                </td>
                <td colspan="4">附&emsp;&emsp;注</td>
              </tr>
              <tr
                v-for="(item, index) in reportData.basicSubjectList"
                :key="item.name"
              >
                <td :colspan="reportData.secondTerm ? '4' : '5'">
                  {{ item.name }}
                </td>
                <td
                  :colspan="reportData.secondTerm ? '4' : '5'"
                  class="input-mark"
                >
                  {{ item.normal }}
                </td>
                <td
                  :colspan="reportData.secondTerm ? '4' : '5'"
                  class="input-mark"
                >
                  {{ item.midTerm }}
                </td>
                <td
                  :colspan="reportData.secondTerm ? '4' : '5'"
                  class="input-mark"
                >
                  {{ item.terminal }}
                </td>
                <td colspan="4" class="input-mark">
                  {{ item.term }}
                </td>
                <td colspan="4" class="input-mark" v-if="reportData.secondTerm">
                  {{ item.year }}
                </td>
                <td
                  v-if="index === 0"
                  colspan="4"
                  :rowspan="reportData.basicSubjectList.length + 5"
                  style="text-align: left"
                >
                  <span class="desc">
                    本学期共上课<br />
                    <u
                      ><span class="input-mark"
                        >&emsp;{{ reportData.totalClassDays }}&emsp;</span
                      ></u
                    >天；
                    <br />
                  </span>
                  <span class="desc">
                    你因病、因事请假<br />
                    <u
                      ><span class="input-mark"
                        >&emsp;{{ reportData.sickAbsenceLeaveDays }}&emsp;</span
                      ></u
                    >天；
                    <br />
                  </span>
                  <span class="desc">
                    无故缺席<br />
                    <u
                      ><span class="input-mark"
                        >&emsp;{{ reportData.truancyDays }}&emsp;</span
                      ></u
                    >天；
                    <br />
                  </span>
                  <span class="desc">
                    实际上课<br />
                    <u
                      ><span class="input-mark"
                        >&emsp;{{ reportData.attendClassDays }}&emsp;</span
                      ></u
                    >天；
                    <br />
                  </span>

                  <span class="desc" style="margin-top: 45px">
                    下学期开学时间为<br />
                    <u
                      ><span class="input-mark"
                        >&emsp;{{ reportData.termBeginMonth }}&emsp;</span
                      ></u
                    >月
                    <u
                      ><span class="input-mark"
                        >&emsp;{{ reportData.termBeginDay }}&emsp;</span
                      ></u
                    >日
                  </span>
                  <span class="desc">
                    报到时间为<br />
                    <u
                      ><span class="input-mark"
                        >&emsp;{{ reportData.reportDutyMonth }}&emsp;</span
                      ></u
                    >月
                    <u
                      ><span class="input-mark"
                        >&emsp;{{ reportData.reportDutyDay }}&emsp;</span
                      ></u
                    >日
                    <br />
                  </span>
                </td>
              </tr>
              <template
                v-if="
                  reportData.featureSubjectList &&
                  reportData.featureSubjectList.length > 0
                "
              >
                <tr
                  v-for="(item, index) in ['', '', '', '', '']"
                  :key="index + '-featureSubjectList'"
                >
                  <td v-if="index === 0" colspan="1" rowspan="5">
                    地方和学校课程
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '3' : '4'"
                    style="height: 31px"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                      reportData.featureSubjectList[index].name
                    }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                      reportData.featureSubjectList[index].normal
                    }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                      reportData.featureSubjectList[index].midTerm
                    }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                      reportData.featureSubjectList[index].terminal
                    }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '4'"
                    class="input-mark"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                      reportData.featureSubjectList[index].term
                    }}
                  </td>
                  <td
                    colspan="4"
                    v-if="reportData.secondTerm"
                    class="input-mark"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                      reportData.featureSubjectList[index].year
                    }}
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr
                  v-for="(item, index) in ['', '', '', '', '']"
                  :key="index + 'else'"
                >
                  <td v-if="index === 0" colspan="1" rowspan="5">
                    地方和学校课程
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '3' : '4'"
                    style="height: 31px"
                  >
                    {{ "" }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '4'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    colspan="4"
                    v-if="reportData.secondTerm"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                </tr>
              </template>
              <tr style="max-height: 60px">
                <td colspan="1">班 主 任</td>
                <td colspan="8">
                  <span v-if="!reportData.classTeacherSeal"></span>
                  <img
                    v-else
                    :src="reportData.classTeacherSeal"
                    style="width: 100%; max-width: 100px"
                    alt="班主任印章"
                  />
                </td>
                <td colspan="2">
                  教务
                  <br />
                  <br />
                  <br />主任
                </td>
                <td colspan="7">
                  <span v-if="!reportData.teachingDirectorSeal"></span>
                  <img
                    v-else
                    :src="reportData.teachingDirectorSeal"
                    style="width: 100%; max-width: 100px"
                    alt="教导主任印章"
                  />
                </td>
                <td colspan="2">
                  校
                  <br />
                  <br />
                  <br />长
                </td>
                <td colspan="8">
                  <span v-if="!reportData.schoolMasterSeal"></span>
                  <img
                    v-else
                    :src="reportData.schoolMasterSeal"
                    style="width: 100%; max-width: 100px"
                    alt="校长印章"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div style="width: 49%; height: 100%; position: relative">
        <!-- page2 -->
        <div class="template">
          <div class="title">综合素质评定记录表</div>
          <div class="term">
            <span>
              （
              <u>&emsp;{{ reportData.termStartYear }}&emsp;</u>—
              <u>&emsp;{{ reportData.termEndYear }}&emsp;</u>学年度第{{
                reportData.secondTerm ? "二" : "一"
              }}学期 </span
            >）
          </div>

          <div class="table-container">
            <table
              cellpadding="28"
              style="height: 100%; width: 100%; margin: 0"
            >
              <tr style="height: 31px">
                <td colspan="4" class="border-none-right">评价维度</td>
                <td
                  colspan="24"
                  rowspan="2"
                  style="padding: 0"
                  class="border-none-left"
                >
                  <table
                    class="border-none"
                    style="height: 100%; width: 100%; margin: 0"
                  >
                    <tr class="border-none" style="height: 50%">
                      <td
                        class="border-none border-left border-bottom"
                        v-for="item in reportData.evalItemList"
                        :key="item.indicatorsName"
                      >
                        {{ item.indicatorsName }}
                      </td>
                    </tr>
                    <tr class="border-none">
                      <td
                        class="border-none border-left border-bottom input-mark"
                        v-for="item in reportData.evalItemList"
                        :key="item.indicatorsName"
                      >
                        {{ item.indicatorsScore }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="border-none-right" style="height: 31px">
                  等级
                </td>
              </tr>
              <tr style="height: 14vh">
                <td colspan="4">
                  <span style="">综合性评语</span>
                </td>
                <td
                  colspan="24"
                  style="padding: 15px; line-height: 14px; text-align: left"
                >
                  <span class="input-mark">{{
                    reportData.generalComment
                  }}</span>
                </td>
              </tr>
              <tr style="height: 6vh; max-height: 4vh">
                <td colspan="4" style="line-height: 14px">
                  班主任
                  <br />（签章）
                </td>
                <td colspan="10">
                  <span v-if="!reportData.classTeacherSeal"></span>
                  <img
                    v-else
                    :src="reportData.classTeacherSeal"
                    style="width: 100%; max-width: 100px"
                    alt="班主任印章"
                  />
                </td>
                <td colspan="4" style="line-height: 14px">
                  德育主任
                  <br />（签章）
                </td>
                <td colspan="10">
                  <span v-if="!reportData.moralDirectorSeal"></span>
                  <img
                    v-else
                    :src="reportData.moralDirectorSeal"
                    style="width: 100%; max-width: 100px"
                    alt="德育主任印章"
                  />
                </td>
              </tr>
              <tr style="height: 14vh; max-height: 16vh">
                <td colspan="4">本学年受过何种奖励或处分</td>
                <td
                  colspan="24"
                  style="padding: 15px; line-height: 14px; text-align: left"
                >
                  <span class="input-mark">{{ reportData.rewardsContent }}</span>
                </td>
              </tr>
              <tr style="height: 14vh; max-height: 16vh">
                <td colspan="4">家长的意见与希望</td>
                <td
                  colspan="24"
                  style="padding: 15px; line-height: 14px; text-align: left"
                >
                  <span class="input-mark">{{ reportData.parentComment }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div style="width: 49%; height: 100%; position: relative">
        <!-- page3 -->
        <div class="template" style="width: calc(100% - 100px)"></div>
      </div>
      <div style="width: 49%; height: 100%; position: relative">
        <!-- page4 -->
        <div class="template" style="width: calc(100% - 100px)">
          <div class="cover-title">
            {{
              Number(this.$store.state.user.schoolStage) === 2 ||
              this.$route.query.stage === 2
                ? "初中"
                : "高中"
            }}学生素质发展报告
          </div>
          <div class="cover-term">
            <span>
              (
              <u>&emsp;{{ reportData.termStartYear }}&emsp;</u>—
              <u>&emsp;{{ reportData.termEndYear }}&emsp;</u>学年度第{{
                reportData.secondTerm ? "二" : "一"
              }}学期</span
            >)
          </div>
          <div class="info">
            <div style="position: absolute; bottom: 8vh">
              <p style="margin-bottom: 3vh">
                姓名：<span class="name input-mark">{{ reportData.studentName }}</span>
              </p>
              <p>
                班级：<span class="class-info input-mark">{{ reportData.className }}</span>
              </p>
            </div>
          </div>
          <div
            class="school-div"
            :style="{
              backgroundImage: 'url(' + reportData.schoolSeal + ')',
            }"
          >
            <span class="school">{{ reportData.schoolName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['reportData', 'subjects'],

  components: {},

  data () {
    return {

    }
  },

  watch: {

  },

  computed: {

  },

  updated () {
  },

  mounted () {

  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
.template {
  max-width: 100%;
  height: calc(100% - 95px);
  position: absolute;
  padding: 45px 50px 50px 50px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.18),
    0px 2px 8px 0px rgba(0, 0, 0, 0.18);
}
.title {
  font-size: 25px;
  font-family: monospace;
  font-weight: bold;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #ff0000;
}
.table-container {
  width: 100%;
  height: calc(100% - 63px);
  max-height: calc(100% - 63px);
  display: flex;
  justify-content: center;
}
table {
  height: 100%;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;
  font-family: STSongti-SC-Regular, STSongti-SC;
}
table,
tr,
td {
  border: 0.3px solid #ff0000;
  color: #ff0000;
  text-align: center;
  vertical-align: middle;
}
td {
  word-wrap: break-word;
  word-break: break-all;
}
.border-none {
  border: 0;
}
.border-none .border-bottom {
  border-bottom: 0.5px solid #ff0000;
}
.border-none .border-bottom-white {
  border-bottom: 1px solid #ff0000;
}
.border-none .border-left {
  border-left: 0.5px solid #ff0000;
}
.border-none-right {
  border-right: 0;
}
.border-none-left {
  border-left: 0;
}
.term {
  height: 20px;
  margin-top: 15px;
  text-align: center;
  color: #ff0000;
}
.desc {
  display: inline-block;
  line-height: 14px;
  padding: 10px 0;
}
.input-mark {
  color: #1b4e81;
}
.cover-title {
  margin-top: 12vh;
  height: 4vh;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ff0000;
  line-height: 40px;
  text-align: center;
}
.cover-term {
  height: 2vh;
  margin-top: 15px;
  text-align: center;
  color: #ff0000;
}
.info {
  font-size: 18px;
  font-weight: 400;
  color: #ff0000;
  height: calc(100% - 18vh - 200px);
  position: relative;
  display: flex;
  justify-content: center;
}
.name {
  display: inline-block;
  min-width: 160px;
  text-align: center;
  line-height: 30px;
  border-bottom: 1px solid #ff0000;
  white-space: nowrap;
}
.class-info {
  display: inline-block;
  min-width: 160px;
  text-align: center;
  line-height: 30px;
  border-bottom: 1px solid #ff0000;
  white-space: nowrap;
}
.school-div {
  text-align: center;
  min-height: 200px;
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.school {
  position: absolute;
  bottom: 0;
  transform: translate(-50%, -20%);
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ff0000;
}
.container {
  box-sizing: border-box;
  width: 29.7cm;
  height: 21cm;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container + .container {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HigherTemplate.vue